import isBoolean from 'lodash-es/isBoolean';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { Flex } from '../../../components/Flex';
import { Input, InputProps } from '../../../components/Input';
import { Text } from '../../../components/Text';
import { Breakpoints } from '../../../theme/Breakpoints';
import { FontSize } from '../../../theme/FontSize';
import { Rounded } from '../../../theme/Rounded';
import { Spacing } from '../../../theme/Spacing';

const InputWrapper = styled(Flex)<{ error?: boolean }>`
  border-radius: ${Rounded.md};
  padding-block: 0.2rem;
  flex-direction: column;
  gap: ${Spacing.s};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    flex-direction: row;
    align-items: center;
    gap: 0;
    background-color: ${({ theme }) => theme.bgSpecialInput};
    padding-inline-start: ${Spacing.s};
    outline: 2px solid
      ${({ theme, error }) => (error ? theme.danger : 'transparent')};
  }
`;

const InputLabel = styled(Text)`
  color: ${({ theme }) => theme.fgPrimary};
  font-weight: 600;
  white-space: nowrap;

  @media (min-width: ${Breakpoints.DESKTOP}) {
    color: ${({ theme }) => theme.main};
  }
`;

const StyledInput = styled(Input)<{ error?: boolean }>`
  background-color: ${({ theme }) => theme.bgSpecialInput};
  font-size: ${FontSize.s};
  font-weight: 600;
  color: ${({ theme }) => theme.fgSpecialInput};
  border: 0 !important;

  @media (max-width: ${Breakpoints.DESKTOP}) {
    outline: 2px solid
      ${({ theme, error }) => (error ? theme.danger : 'transparent')} !important;
  }

  @media (min-width: ${Breakpoints.DESKTOP}) {
    background-color: ${({ theme }) => theme.transparent};
  }
`;

const DangerSpan = styled.span`
  color: ${({ theme }) => theme.danger};
`;

type LinkInputProps = InputProps;

export const LinkInput = forwardRef<HTMLInputElement, LinkInputProps>(
  ({ title, valid, errorMessage, ...props }, ref) => {
    return (
      <Flex width={'100%'} flexDirection="column" gap="s" ref={ref}>
        <InputWrapper error={typeof valid === 'boolean' && !valid}>
          {title ? (
            <InputLabel>
              {props?.required ? <DangerSpan>* </DangerSpan> : null}

              {title}
            </InputLabel>
          ) : null}

          <StyledInput error={isBoolean(valid) && !valid} {...props} />
        </InputWrapper>

        {!valid && errorMessage ? (
          <Text color="danger" fontSize="s">
            {errorMessage}
          </Text>
        ) : null}
      </Flex>
    );
  },
);
